import { render, staticRenderFns } from "./edit-user-create-business-profile.vue?vue&type=template&id=16351031&scoped=true&"
import script from "./edit-user-create-business-profile.vue?vue&type=script&lang=js&"
export * from "./edit-user-create-business-profile.vue?vue&type=script&lang=js&"
import style0 from "./edit-user-create-business-profile.vue?vue&type=style&index=0&id=16351031&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16351031",
  null
  
)

export default component.exports